<script setup lang="ts">
import MenuSearchResultItem from '@/common/components/organisms/menuSearch/menuSearchContent/menuSearchResult/MenuSearchResultItem.vue';

import { setup } from './menuSearchRecent.setup';

const { menuSearchRecentItems, handleClick } = setup();
</script>

<template>
  <ul class="menu-search-recent">
    <menu-search-result-item
      v-for="item in menuSearchRecentItems"
      :id="item.id"
      :key="item.id"
      :icon="item.icon"
      :featured-icon="item.featuredIcon"
      :title="item.title"
      :path="item.path"
      @on-click="() => handleClick(item)"
    >
      <template #subTitle>
        <span class="menu-sub-title">{{ item.subTitle }}</span>
      </template>
    </menu-search-result-item>
  </ul>
</template>
